import s from "./Section.module.scss"
import { IChildren } from "@/interfaces/IChildren"
import { FC } from "react"
import cn from "classnames"

interface ISection extends IChildren {
    color?: string
    id?: string
}

const Section: FC<ISection> = ({id, children, color = "black"}) => {
    return (
        <section id={id} className={cn(s.section, s[color])}>
            {color === "green" && <div className={s.visualBlock}/>}
            {children}
        </section>
    )
}

export default Section